// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
import { versions } from './versions';

const version = versions ? versions : null;

// Disable whitespace linting so powershell interpolation will not break the build
/* tslint:disable whitespace */
export const environment = {
envname:'UAT',
baseUrl:'https://uateproveapi.advanc-ed.org/strategies-api/v1',
usersApiUrl:'https://uateproveapi.advanc-ed.org/users-api/v1',
customerApiUrl:'https://uateproveapi.advanc-ed.org/customer-api/v1',
resetUrl:'https://uateprovestrategies.advanc-ed.org/auth/confirm-reset/',
resourceBase:'https://uateprovereports.advanc-ed.org',
my_journey_url:'https://uatmyjourney.cognia.org/',
production: false,
  logoutEndPoint: 'logout',
  privacyPolicyUrl: 'https://static.cognia.org/privacy-policy.html',
  version
};
